<template lang="pug">
  component.c-avatar(
    :is="isUserInfo ? 'a' : 'div'",
    :href="mypageHref",
    :class="sizeClass",
    target="_parent",
    rel="nofollow"
  )
    .c-crop.c-crop--circle
      img.c-crop__img(
        :src="dummyAvatarSrc",
        :key="avatarSrc",
        v-lazy="{src: avatarSrc, error: dummyAvatarSrc, loading: dummyAvatarSrc}",
        :class='cropModifierClass',
        :alt='userName'
      )
    span.c-avatar__country.c-tooltip.c-tooltip--se(v-if="hasUserLocation && size !== 'xs'", :data-tooltip="userLocation.name")
      img(:src="userLocation.src", :srcset="`${userLocation.src} 1x, ${userLocation.src2x} 2x`", :alt="userLocation.name")
</template>

<script>
import { default as urlUtil } from '../../util/url';

import COUNTRIES from '../../../../../../lib/data/shop/user_location_countries.json';
const LOCATION_FLAGS_PATH = '/static/common/flags/square/';

export default {
  props: {
    user: Object,
    size: String
  },
  computed: {
    isUserInfo() {
      return !!(this.user && this.user._id && this.user.name);
    },

    userName() {
      if (!this.isUserInfo) {
        return 'Account Deleted';
      }
      return this.user.name;
    },

    sizeClass() {
      return {
        'c-avatar--xs': this.size === 'xs',
        'c-avatar--sm': this.size === 'sm',
        'c-avatar--xl': this.size === 'xl'
      };
    },

    mypageHref() {
      if (!this.isUserInfo) {
        return undefined;
      }
      const pathname = this.user.user_name || this.user._id;
      return `/${pathname}`;
    },

    avatarSrc() {
      if (!this.isUserInfo) {
        return this.dummyAvatarSrc;
      }
      return this.webp(this.user.avatar_image && this.user.avatar_image.source);
    },

    dummyAvatarSrc() {
      return urlUtil.cloudImageUrl('/static/common/noAvatarImage100.png');
    },

    cropModifierClass() {
      if (
        this.isUserInfo &&
        this.user.avatar_image &&
        (this.user.avatar_image.width > this.user.avatar_image.height)
      ) {
        return 'c-crop__img--h';
      }
      return '';
    },

    hasUserLocation() {
      return !!(this.isUserInfo && this.user.location);
    },

    userLocation() {
      if (!this.hasUserLocation) {
        return {};
      }
      return {
        src: urlUtil.cloudImageUrl(`${LOCATION_FLAGS_PATH}64/${this.user.location}.png`),
        src2x: urlUtil.cloudImageUrl(`${LOCATION_FLAGS_PATH}128/${this.user.location}.png`),
        name: COUNTRIES[this.user.location]
      };
    },

  },

  methods: {
    webp: urlUtil.webp
  }
};

</script>

<style scoped>

</style>
